import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AmplitudeService } from './amplitude.service';

declare global {
    interface Window {
        PerformanceTracker?: {
            trackLoad: (pageUrl: string) => Promise<{
                url: string;
                pageTitle: string;
                appInitTime: number;
                loadTime: number | null;
            }> | null;
        };
    }
}

@Injectable({
    providedIn: 'root'
})
export class PerformanceTrackerService {
    private isTrackingEnabled = false;
    private lastTrackedUrl: string | null = null;

    constructor(private router: Router, private amplitude: AmplitudeService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd && this.isTrackingEnabled) {
                if (event.urlAfterRedirects !== this.lastTrackedUrl) {
                    this.lastTrackedUrl = event.urlAfterRedirects;
                    this.trackPageLoad(event.urlAfterRedirects);
                }
            }
        });
    }

    private async trackPageLoad(pageUrl: string): Promise<void> {
        if (!window.PerformanceTracker?.trackLoad) return;

        try {
            const result = await window.PerformanceTracker.trackLoad(pageUrl);

            if (result != null && result.loadTime != null) {
                console.log('Page: ', result.pageTitle, ' loaded in ', result.loadTime, 'ms');
                this.sendToAmplitude(result.url, result.pageTitle, result.loadTime, result.appInitTime);
            }
        }
        catch (err) {
            console.log('Error tracking page load:', err);
        }
    }

    private sendToAmplitude(pageUrl: string, pageTitle: string, loadTime: number, appInitTime: number): void {
        this.amplitude.track('Page Load', {
            pageTitle,
            url: pageUrl,
            loadTimeSeconds: loadTime > 0 ? Math.round((loadTime / 1000) * 100) / 100 : loadTime,
            appInitTime,
        });
    }

    enableTracking(isEnabled: boolean): void {
        this.isTrackingEnabled = isEnabled;
    }
}
